import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '../../interfaces/mapped-http-error-response.interface';
import {Extras} from '@sentry/types/types-ts3.8/extra';


export class SentryActions {

  public static captureException = createAction(
    '[Sentry] Captures the exception and sends it so sentry.',
    props<{
      error: MappedHttpErrorResponse,
      extras: Extras,
    }>(),
  );

}
